import React, { useEffect, useState } from "react";
import "./OwnerHistory.css";
import { getNftOwnerHistory } from "../../../api/nft/nft";
import { errorMessageHandler, fetchNftownerDetail, fetchUserProfileImage, formatDate } from "../../../utils/utils";
import { Link } from "react-router-dom";

const OwnerHistory = ({ id }) => {
    const [ownerHistoryLoading, setOwnerHistoryLoading] = useState(true)
    const [ownerHistoryLoadingError, setOwnerHistoryLoadingError] = useState("")
    const [nftOwnerHistory, setNftOwnerHistory] = useState([])

    useEffect(() => {
        getOwnerHistory()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    let getOwnerHistory = async () => {
        try {
            setOwnerHistoryLoading(true)
            let { data } = await getNftOwnerHistory(id)
            setOwnerHistoryLoading(false)
            setNftOwnerHistory(data.data.ownership_history)
        }
        catch (e) {
            setOwnerHistoryLoading(false)
            setOwnerHistoryLoadingError(errorMessageHandler(e))
        }
    }

    return (
        <div
            className="tab-pane fade"
            id="owners"
            role="tabpanel"
            aria-labelledby="owners-tab"
        >
            {
                ownerHistoryLoading === true ? (
                    <div className="OwnerHistory__container">
                        <div className="OwnerHistory__loadingState">
                            <div className="OwnerHistory__loadingSpinner"></div>
                            <p style={{ marginTop: '20px', color: '#6b7280', fontSize: '15px' }}>Loading ownership history...</p>
                        </div>
                    </div>
                ) : ownerHistoryLoadingError ? (
                    <div className="OwnerHistory__container">
                        <div className="text-center py-4" style={{ maxWidth: '450px', margin: '40px auto', padding: '30px 20px' }}>
                            {/* Error Icon Container */}
                            <div style={{
                                width: '120px',
                                height: '120px',
                                margin: '0 auto 24px',
                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                position: 'relative'
                            }}>
                                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                </svg>
                            </div>

                            {/* Error Title */}
                            <h3 style={{
                                color: '#1a1a1a',
                                marginBottom: '12px',
                                fontSize: '26px',
                                fontWeight: '700',
                                lineHeight: '1.2',
                                letterSpacing: '-0.5px'
                            }}>
                                Unable to Load Owners
                            </h3>

                            {/* Error Message */}
                            <p style={{
                                color: '#6b7280',
                                fontSize: '15px',
                                lineHeight: '1.6',
                                marginBottom: '0',
                                fontWeight: '500'
                            }}>
                                Something went wrong while loading the ownership history. Please try again later.
                            </p>
                        </div>
                    </div>
                ) : nftOwnerHistory?.length === 0 ? (
                    <div className="OwnerHistory__container">
                        <div className="text-center py-4" style={{ maxWidth: '450px', margin: '40px auto', padding: '30px 20px' }}>
                            {/* Icon Container */}
                            <div style={{
                                width: '120px',
                                height: '120px',
                                margin: '0 auto 24px',
                                background: 'linear-gradient(135deg, rgba(105, 239, 183, 0.1), rgba(17, 207, 243, 0.1))',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '3px solid rgba(105, 239, 183, 0.2)',
                                position: 'relative',
                                animation: 'iconFloat 3s ease-in-out infinite'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '120%',
                                    height: '120%',
                                    background: 'radial-gradient(circle, rgba(105, 239, 183, 0.2) 0%, rgba(17, 207, 243, 0.15) 40%, transparent 70%)',
                                    borderRadius: '50%',
                                    animation: 'glowPulse 3s ease-in-out infinite'
                                }}></div>
                                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#69efb7', filter: 'drop-shadow(0 4px 16px rgba(105, 239, 183, 0.4))', position: 'relative', zIndex: 1 }}>
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </div>

                            {/* Title */}
                            <h2 style={{
                                color: '#1a1a1a',
                                marginBottom: '12px',
                                fontSize: '26px',
                                fontWeight: '700',
                                lineHeight: '1.2',
                                letterSpacing: '-0.5px'
                            }}>
                                No Ownership History
                            </h2>

                            {/* Description */}
                            <p style={{
                                color: '#6b7280',
                                fontSize: '15px',
                                lineHeight: '1.6',
                                marginBottom: '0',
                                fontWeight: '500'
                            }}>
                                This NFT doesn't have any ownership history yet.
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="OwnerHistory__container">
                        <div className="OwnerHistory__list">
                            {[...nftOwnerHistory].reverse().map((o, i) => {
                                const isCurrentOwner = i === 0;
                                const isPreviousOwner = i === 1;
                                const showBadge = isCurrentOwner || (nftOwnerHistory.length === 1);

                                return (
                                    <div key={i} className="OwnerHistory__card">
                                        <div className="OwnerHistory__avatarContainer">
                                            <div className="OwnerHistory__avatar">
                                                <img
                                                    src={fetchUserProfileImage(o?.to_user_details?.profile_image)}
                                                    alt={o?.to_user_details?.user_name || "Owner"}
                                                />
                                            </div>
                                            {showBadge && (
                                                <div className="OwnerHistory__badge">
                                                    👑
                                                </div>
                                            )}
                                        </div>

                                        <div className="OwnerHistory__content">
                                            <div className="OwnerHistory__info">
                                                <Link to={`/profile/${o?.to_user_details?.user_name}`}>
                                                    <div className="OwnerHistory__name">
                                                        {fetchNftownerDetail(o.action, o.to_user_details, o.from_user_details)}
                                                    </div>
                                                </Link>
                                                {isCurrentOwner && (
                                                    // <Link to={`/profile/${o?.to_user_details?.user_name}`} className="OwnerHistory__link">
                                                    <span className="OwnerHistory__label OwnerHistory__label--current">
                                                        Current Owner
                                                    </span>
                                                    // </Link>
                                                )}
                                                {isPreviousOwner && (
                                                    // <Link to={`/profile/${o?.to_user_details?.user_name}`} className="OwnerHistory__link">
                                                    <span className="OwnerHistory__label OwnerHistory__label--previous">
                                                        Previous Owner
                                                    </span>
                                                    // </Link>
                                                )}
                                            </div>
                                            <div className="OwnerHistory__timestamp">
                                                {formatDate(o.timestamp)}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default OwnerHistory;